import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { BaseApi } from 'src/backend/api/base-api';

@Component({
  selector: 'app-new-chat',
  templateUrl: './new-chat.component.html',
  styleUrls: ['./new-chat.component.scss']
})
export class NewChatComponent implements OnInit {
  @Input() isFullWidth: boolean = false;
  @Input() draggingWidth: boolean = false;
  plantSession: any;
  plantName: any;
  constructor(
    private baseApi: BaseApi,
  ) { }

  ngOnInit() {
    this.getPlantName();
  }

  getPlantName(): void {
    this.plantSession = this.baseApi.getPlantFromStorage();
    this.plantName = this.plantSession?.plantName;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isFullWidth']) {
      console.log('Full Width mode changed in app-new-chat:', this.isFullWidth);
      // Perform additional actions if needed
    }
    if (changes['draggingWidth']) {
      console.log('Narrow mode changed in app-new-chat:', this.draggingWidth);
      // Perform additional actions if needed
    }
  }
}
